import React, {Component} from 'react';
import List from './List';
import ConverterModal from './ConverterModal';

class StatusDrawer extends Component {
    constructor(props) {
      super(props);
        this.state = {
            accepted:true,
            rejected:true,
            current:this.props.red,
            converterOpen:false,

            redOpen:true,
            greenOpen:true,
            blueOpen:true,

        }
    }

    clearLists(){
        this.props.clear()
    }

    hide=()=>{
        this.props.hide()
    }
    
    green(){
        this.setState((prevState)=>{
            return {greenOpen:!prevState.greenOpen}
        })
    }

    red(){
      this.setState((prevState)=>{
            return {redOpen:!prevState.redOpen}
        })

    }

    blue(){
        this.setState((prevState)=>{
            return {blueOpen:!prevState.blueOpen}
        })
    }

    componentDidMount(prevState) {
       // this.red(prevState)
    
    }
    
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.red!==this.props.red || prevProps.green!==this.props.green || prevProps.blue!==this.props.blue ){
        }

        if(prevProps.setNumber!==this.props.setNumber){
        }
        }

        newsOpen(){
            this.props.newsOpen()
        }


    Showlist=()=>{
        this.props.list()
    }
    render(){

        let converterModalClose = () => this.setState({converterOpen:false})
        let converterModalOpen = () => this.setState({converterOpen:true})

        let warning = ''
        let signRed= <span className="right"><i class="fas fa-chevron-up"></i></span>;
        let signGreen= <span className="right"><i class="fas fa-chevron-up"></i></span>;
        let signBlue= <span className="right"><i class="fas fa-chevron-up"></i></span>;
        let toggle = <span className='toggleOn'><i class="fas fa-toggle-on" ></i></span>


        if(!this.state.redOpen){
            signRed = <span className="right"><i class="fas fa-chevron-down"></i></span>
            toggle = <span className='toggleOff'><i class="fas fa-toggle-off"></i></span>
        }

        if(!this.state.greenOpen){
            signGreen = <span className="right"><i class="fas fa-chevron-down"></i></span>
        }

        if(!this.state.blueOpen){
            signBlue = <span className="right"><i class="fas fa-chevron-down"></i></span>
        }
        
        let drawerClasses = 'status-drawer';
        if(this.props.show){
            drawerClasses='status-drawer open';     
           
    }
    let customText = ""
    if(!this.props.news){
       customText = "See News"
    }
    else{
        customText = "See Market"  
    }
    

    
 
    return(
    <nav className={drawerClasses}> 
        <button className="closeBtn" onClick={this.hide}>X</button>
        <div className="kadena mt-5 ml-3 mr-3">
        <i class="fab fa-old-republic"></i>
        <h4>QUatRO</h4>
        
      
        </div> 

        <select onChange={this.props.changeSet} value = {this.props.setNumber} className="optionsDrawer">
            <option value="1" key="1" className="options" >Set 1</option>
			<option value="2" key="2" className="options">Set 2</option>
            <option value="3" key="3" className="options">Set 3</option>
            <option value="4" key="4" className="options">Set 4</option>
        </select>   

        <div className="profile mt-3 ">
      
        
				<p className="mt-1 small" title="Show Red Status" onClick={()=>this.red()}><span>  <button className="add2 mr-1"/> Red: {this.props.red.length}</span>{signRed}</p>			
                {this.state.redOpen && 
                <div className="profile ml-3 mr-3">
                        {this.props.red.sort((a,b)=>a[3] - b[3]).map((list,index)=>(
                            <a href={"#"+list[0]} className="anchor">
                                <p className="mt-1 small" index={index} key={index}><span>{index + 1}. {list[0]}</span> <a href={"https://www.binance.com/en/trade/" +list[2]} target="blank" className="percentageNegative" title={'Width: '+ list[3] +'%'}>{list[1]}%</a></p>
                            </a>))
                    }
                </div>}

                <p className="mt-1 small" title="Show Green Status" onClick={()=>this.green()}><span> <button className="superb2 mr-1"/> Green: {this.props.green.length}</span>{signGreen}</p>
				{this.state.greenOpen && 
                <div className="profile ml-3 mr-3">
                        {this.props.green.sort((a,b)=>b[1] - a[1]).map((list,index)=>(
                            <a href={"#"+list[0]} className="anchor">
                                <p className="mt-1 small" index={index} key={index}><span>{index + 1}. {list[0]} <a href={"https://www.binance.com/en/trade/" +list[2]} target="blank" className="percentagePositive" title={'Width: '+ list[3] +'%'}>+{list[1]}%</a></span></p>
                            </a>))
                    }
                </div>}
                
                
               
                
                <p className="mt-1 small" title="Show Blue Status" onClick={()=>this.blue()}><span> <button className="warning2 mr-1"/> Blue:  {this.props.blue.length}</span>{signBlue}</p>			
                {this.state.blueOpen && 
                <div className="profile ml-3 mr-3">
                        {this.props.blue.sort((a,b)=>b[1] - a[1]).map((list,index)=>(
                            <a href={"#"+list[0]} className="anchor">
                                <p className="mt-1 small" index={index} key={index}><span>{index + 1}. {list[0]}<a href={"https://www.binance.com/en/trade/" +list[2]} target="blank" className="percentagePositive2" title={'Width: '+ list[3] +'%'}>+{list[1]}%</a></span></p>
                            </a>))
                    }
                </div>}
                <p className="mt-1 small" title="Show Blue Status"  onClick={() => this.setState({ converterOpen:true})}><span><i class="fas fa-exchange-alt mr-1"></i> Converter</span></p>	
                

                {this.state.converterOpen&&<ConverterModal
                 show={converterModalOpen}
                 onHide={converterModalClose}
                 aria-labelledby="ModalHeader"
                />}
               <p className="mt-1 small" onClick={() =>this.newsOpen()}> <i class="fas fa-chess-knight mr-2"></i>{customText}</p>
               <p className="mt-1 small"  onClick={this.Showlist}> <i class="fas fa-jedi mr-2"></i>My List</p>
               <hr />
               
            </div>

           
      
    </nav>
);
    }
}
export default StatusDrawer;